import { render } from "./DeliveryStatus.vue?vue&type=template&id=18307d3e&scoped=true"
import script from "./DeliveryStatus.vue?vue&type=script&lang=js"
export * from "./DeliveryStatus.vue?vue&type=script&lang=js"

import "./DeliveryStatus.vue?vue&type=style&index=0&id=18307d3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18307d3e"]])

export default __exports__